<span
  *ngIf="depositsEnabled() && depositRequired()"
  class="text-warn-800 flex items-center gap-1 whitespace-nowrap rounded-md bg-amber-100 px-2 py-1 text-xs"
>
  <mat-icon class="icon-xs">attach_money</mat-icon>
  Deposit required
</span>
